import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import '../Utility/Normalize.js';
import { SvgWrapper } from '../Utility/SvgWrapper.js';
import '../Utility/UnstyledList.js';

const ChevronLeft = forwardRef(function ChevronLeft(props, ref) {
    return (jsx(SvgWrapper, Object.assign({ fill: "none", height: "24", viewBox: "0 0 24 24", width: "24" }, props, { ref: ref, children: jsx("path", { clipRule: "evenodd", d: "M15.8412 7.50115L11.3412 12.0011L15.8412 16.5011L14.2502 18.0921L8.15918 12.0011L14.2502 5.91016L15.8412 7.50115Z", fill: "currentColor", fillRule: "evenodd" }) })));
});

export { ChevronLeft as default };
//# sourceMappingURL=ChevronLeft.js.map
